export default __webpack_public_path__ + "static/media/landscape3-MASK-zahner2.3a767a1e.png";